// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","messageFundButton":"UFgNfsRVo_DdnSA2vYBH1","messageFundModalTextArea":"_1_GdZLQNoc369K_C_wy7yZ","messageFundModalButtons":"_2wEKeXmV8C8YphZ8XfdC6d"};